import script from "./TableTreinamentos.vue?vue&type=script&setup=true&lang=js"
export * from "./TableTreinamentos.vue?vue&type=script&setup=true&lang=js"

import "./TableTreinamentos.vue?vue&type=style&index=0&id=3ec09042&lang=sass"

const __exports__ = script;

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QInput,QIcon,QTd});
